// NPM imports
import React, { Component } from "react";
import { connect } from "react-redux";

// Components Imports
import BundleEditor from "../BundleEditor";
import DIYPricing from "../DIYPricing";
import FlatPriceEditor from "../FlatPriceEditor";
import PercentageOfTotal from "../PercentageOfTotal";
import PriceMatrixEditor from "../PriceMatrixEditor";
import PricingMethodOptions from "./PricingMethodOptions";

// Internal Imports
import { PRICEBOOK, GRID } from "../../../constants";
import { GlobalUtils } from "../../../utils";

// Actions Imports
import PricebooksActions from "../../../actions/PricebooksActions";

// Destructuring
const { twoArrayLookUp } = GlobalUtils;
const { updatePricingMethodData } = PricebooksActions;

// Destructuring
const { PRICING_METHODS, PRICING_METHODS_LABELS } = GRID;
const { PRICING_TYPES } = PRICEBOOK;

// Component Code Starts
class PricingMethodWrapper extends Component {
  componentDidMount() {
    // Update the state
    let pricingMethod = "";
    const { fieldMapIndex, data, products, unusedProducts } = this.props;
    const productId = data[fieldMapIndex.product];
    const productDetails = twoArrayLookUp(products, unusedProducts, productId);

    if (
      data[fieldMapIndex.price] &&
      data[fieldMapIndex.price].type &&
      data[fieldMapIndex.price].type === PRICING_METHODS.NON_LINEAR
    ) {
      pricingMethod = PRICING_METHODS.BUNDLE_PRICING;
    } else {
      pricingMethod =
        (data[fieldMapIndex.price] && data[fieldMapIndex.price].type) ||
        PRICING_METHODS.FLAT_PRICE;
    }

    // Update Redux
    this.props.updatePricingMethodData({
      product: productDetails,
      view: pricingMethod,
    });
  }

  _onViewChange = event => {
    this.props.updatePricingMethodData("view", event.target.value);
  };

  _decideView = () => {
    switch (this.props.pricingMethodData.view) {
      case PRICING_METHODS.FLAT_PRICE:
        return <FlatPriceEditor {...this.props} />;
      case PRICING_METHODS.STEP_TIER_PRICING:
      case PRICING_METHODS.TIER_PRICING:
      case PRICING_METHODS.VOLUME_PRICING:
        return (
          <PriceMatrixEditor
            isEdit={this.props.isEdit}
            type={this.props.pricingMethodData.view}
            {...this.props}
          />
        );
      case PRICING_METHODS.BUNDLE_PRICING:
        return (
          <BundleEditor
            isEdit={this.props.isEdit}
            currencySymbol={this.props.currencySymbol}
          />
        );
      case PRICING_METHODS.PERCENTAGE_OF_TOTAL:
        return <PercentageOfTotal />;
      case PRICING_METHODS.DIY_PRICING:
        return <DIYPricing {...this.props} />;
      default:
        return null;
    }
  };

  render() {
    const heading = this.props.isEdit
      ? `Update Pricing Method`
      : `Pricing Method`;
    return (
      <div className="pricingmethodwrapper-wrapper">
        <div className="pricingmethod-title">
          <span className="pricingmethodwrapper-header">{heading}</span>
          <span className="pricingmethodwrapper-subheader">
            For {this.props.pricingMethodData.product.name}
          </span>
        </div>
        {/* Section to choose Pricing Type */}
        <section className="pricingmethodwrapper-selections">
          <div
            className="pricing-radio-buttons"
            onChange={event => this._onViewChange(event)}
            data-test="pricingmethodwrapper-div">
            {PRICING_TYPES.map(type => (
              <PricingMethodOptions
                type={type}
                pricingMethodData={this.props.pricingMethodData}
                pricingMethodLabels={PRICING_METHODS_LABELS}
              />
            ))}
          </div>
        </section>
        {/* Show body section based on pricing type selected  */}
        <div className="pricematrixeditor-wrapper">
          <section className="pricing-preview">
            <div className="pricing-preview-title">
              {PRICING_METHODS_LABELS[this.props.pricingMethodData.view]}{" "}
              Details
            </div>
          </section>
        </div>
        <section className="pricingmethodwrapper-body">
          {this._decideView()}
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    products,
    unusedProducts,
    metaData,
    formRowData,
    pricingMethodData,
  } = state.PricebookStore;
  return {
    fieldMapIndex: metaData.fieldMapIndex,
    data: formRowData,
    products,
    unusedProducts,
    pricingMethodData,
  };
};

const mapDispatchToProps = {
  updatePricingMethodData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PricingMethodWrapper);



// WEBPACK FOOTER //
// ./src/components/Pricebook/PricingMethodWrapper/PricingMethodWrapper.js